<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT" id="_idParaDest-8"><span class="CharOverride-8"> </span></p>
<p class="Cardiff"><a id="_idTextAnchor002"></a><a href="#/97808021580176#_idTextAnchor001">CARDIFF</a>, BY THE SEA</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802158017-7.vue?11a47211